<template>
  <div>
    <el-cascader
      v-model="value"
      :options="jobs"
      :props="prop"
      @change="onJobsChanged"></el-cascader>
  </div>
</template>

<script>


export default{

  name: 'ZchichenSelect',
  
  data(){
    return {
      value : [],
      jobs: [
        {
          value : 1,
          label: "管理人员",
          children: [
            {
              value : 4,
              label: "处级领导干部",
            },
            {
              value : 5,
              label: "处级以下公务员",
            },
            {
              value : 6,
              label: "处级以下事业单位干部",
            },
          ]
        },
        {
          value : 2,
          label: "专技人员"
        },
        {
          value : 3,
          label: "离退休人员"
        },
      ],
      prop: {

      }
    }
  },
  methods:{
    onJobsChanged(val){
      
      let id = val[val.length-1]
      // console.log("onJobsChanged",val,id)

      this.$emit("onDataChanged",id);

    },

    updateVal(val){

      let array = new Array();

      if(val > 3){
        array.push(1);
        array.push(val * 1);
      }
      else {
        array.push(val * 1);
      }

      console.log("ZhichenSelect",val,array)

      this.value = array
    }
  },

  

}
</script>
<style scoped>
.title {
  font-size: 14px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}
</style>